// Shared custom popups (replacing the browser prompt()/confirm()). The only
// browser-native dialog we keep is the deck-editor unsaved-changes back-out.
import { useState } from 'react';

/** A yes/no confirmation dialog. */
export function ConfirmDialog({ title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', danger, onConfirm, onCancel }: {
  title: string; message?: string; confirmLabel?: string; cancelLabel?: string; danger?: boolean;
  onConfirm: () => void; onCancel: () => void;
}) {
  return (
    <div className="pt-popup-backdrop" onClick={onCancel}>
      <div className="pt-popup pt-confirm" onClick={e => e.stopPropagation()}>
        <p className="pt-popup-title">{title}</p>
        {message && <p className="pt-confirm-text muted">{message}</p>}
        <div className="pt-pos-actions">
          <button type="button" className={danger ? 'btn-danger' : 'create-deck-btn'} onClick={onConfirm}>{confirmLabel}</button>
          <button type="button" onClick={onCancel}>{cancelLabel}</button>
        </div>
      </div>
    </div>
  );
}

/** Ask for a positive integer (1..max). Enter submits. Replaces window.prompt. */
export function NumberPrompt({ title, max, defaultValue = 3, onSubmit, onCancel }: {
  title: string; max: number; defaultValue?: number; onSubmit: (n: number) => void; onCancel: () => void;
}) {
  const [val, setVal] = useState(String(Math.min(Math.max(1, defaultValue), Math.max(1, max))));
  const nudge = (d: number) => setVal(v => { const n = parseInt(v, 10) || 0; return String(Math.max(1, Math.min(max, n + d))); });
  const submit = () => {
    const n = parseInt(val, 10);
    if (Number.isFinite(n) && n > 0) onSubmit(Math.min(n, max));
    else onCancel();
  };
  return (
    <div className="pt-popup-backdrop" onClick={onCancel}>
      <form className="pt-popup pt-confirm" onClick={e => e.stopPropagation()} onSubmit={e => { e.preventDefault(); submit(); }}>
        <p className="pt-popup-title">{title}</p>
        <div className="pt-num-row">
          <button type="button" className="pt-num-btn" onClick={() => nudge(1)} aria-label="increase">+</button>
          <input type="number" className="pt-num-input" autoFocus min={1} max={max} value={val}
            onChange={e => setVal(e.target.value)} onFocus={e => e.target.select()} />
          <button type="button" className="pt-num-btn" onClick={() => nudge(-1)} aria-label="decrease">−</button>
        </div>
        <p className="pt-confirm-text muted">1–{max}</p>
        <div className="pt-pos-actions">
          <button type="submit" className="create-deck-btn">OK</button>
          <button type="button" onClick={onCancel}>Cancel</button>
        </div>
      </form>
    </div>
  );
}
